module.exports = "//static.hsappstatic.net/LoginUI/static-1.8917/img/warning.svg"